<template>
  <div class="app" id="app">
    <canvas ref="canvas" class="bg-canvas"></canvas>


    <a href="https://wa.me/40740971216" target="_blank" class="whatsapp-float floating-btn">
      <i class="fab fa-whatsapp"></i>
    </a>
    <div class="min-vh-100 py-5 mb-5 mt-5  d-flex justify-content-center align-items-center text-white position-relative z-1">
      <div class="terminal-box p-4 rounded shadow">
<div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mb-3 flex-wrap">
          <div class="d-flex align-items-center gap-2">
            <img src="/favicon.png" alt="logo" class="logo-terminal" />
            <span class="terminal-title">{{ $t('boss.boss') }}<br />
            <p style="font-size: 14px">{{ $t('home.cui') }}</p> </span>
          </div>

          <div>
            <router-link to="/" class="btn mx-2 mt-2 nav-btn fw-bold" active-class="nav-btn-active" exact>
              {{ $t('menu.home') }}
            </router-link>

            <router-link to="/portfolio" class="btn mx-2 mt-2 fw-bold nav-btn" active-class="nav-btn-active">
              {{ $t('menu.portfolio') }}
            </router-link>

            <router-link to="/contact" class="btn mx-2 mt-2 fw-bold nav-btn" active-class="nav-btn-active">
              {{ $t('menu.contact') }}
            </router-link>

            <div class="dropdown d-inline-block lang-dropdown align-self-center">
              <button class="btn nav-btn mx-2 mt-2 fw-bold dropdown-toggle" type="button" data-bs-toggle="dropdown">
                {{ currentLangName }}
              </button>
<ul
  class="dropdown-menu dropdown-menu-dark p-2"
  style="min-width: 200px; max-height: 250px; overflow-y: auto;"
>
  <li class="mb-2">
    <input
      type="text"
      v-model="searchTerm"
      class=" custom-input "
      placeholder="..."
    />
  </li>
  <li
    v-for="lang in filteredLanguages"
    :key="lang.code"
    class="dropdown-item px-2"
  >
    <a href="#" @click.prevent="setLang(lang.code)" class="d-flex align-items-center gap-2 text-white">
      <span>{{ flags[lang.code] }}</span> {{ lang.name }}
    </a>
  </li>
</ul>

            </div>
          </div>
        </div>

<div class="terminal-content py-5">
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</div>

      </div>
    </div>

  </div>
  <CookieModal />

</template>
<script setup>
import { useI18n } from 'vue-i18n'
import { onMounted, ref, computed, watch } from 'vue'
import CookieModal from '@/components/CookieModal.vue'

const canvas = ref(null)
const { locale } = useI18n()
import { useHead } from '@vueuse/head'

const { t } = useI18n()
const searchTerm = ref('')

useHead({
  title: t('home.seo_title'),
  meta: [
    { name: 'description', content: t('home.seo_description') },
    { name: 'keywords', content: t('home.seo_keywords') },
    { property: 'og:title', content: t('home.seo_title') },
    { property: 'og:description', content: t('home.seo_description') },
    { property: 'og:url', content: 'https://rusin.ro' },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: 'https://rusin.ro/favicon.png' }
  ]
})

const languages = {
  ro: 'Română',
  en: 'English', fr: 'Français', de: 'Deutsch', es: 'Español', it: 'Italiano',
  bg: 'Български', hu: 'Magyar', pl: 'Polski', cs: 'Čeština', sk: 'Slovenčina',
  sl: 'Slovenščina', sq: 'Shqip', sr: 'Српски', bs: 'Bosanski', mk: 'Македонски',
  uk: 'Українська',
  nl: 'Nederlands', sv: 'Svenska', no: 'Norsk', da: 'Dansk', fi: 'Suomi',
  el: 'Ελληνικά', pt: 'Português', ru: 'Русский',
  tr: 'Türkçe', ar: 'العربية', he: 'עברית', fa: 'فارسی', ur: 'اردو',
  af: 'Afrikaans', ne: 'नेपाली', hi: 'हिन्दी', th: 'ไทย', vi: 'Tiếng Việt', id: 'Bahasa Indonesia',
  zh: '中文', ja: '日本語', ko: '한국어',
  la: 'Latina'
}

const flags = {
  ro: '🇷🇴',

  en: '🇬🇧', fr: '🇫🇷', de: '🇩🇪', es: '🇪🇸', it: '🇮🇹',

  bg: '🇧🇬', hu: '🇭🇺', pl: '🇵🇱', cs: '🇨🇿', sk: '🇸🇰',
  sl: '🇸🇮', sq: '🇦🇱', sr: '🇷🇸', bs: '🇧🇦', mk: '🇲🇰',
  uk: '🇺🇦', ru: '🇷🇺',

  nl: '🇳🇱', sv: '🇸🇪', no: '🇳🇴', da: '🇩🇰', fi: '🇫🇮',
  el: '🇬🇷', pt: '🇵🇹',

  tr: '🇹🇷', ar: '🇸🇦', he: '🇮🇱', fa: '🇮🇷', ur: '🇵🇰',
  af: '🇿🇦', ne: '🇳🇵', hi: '🇮🇳', th: '🇹🇭', vi: '🇻🇳', id: '🇮🇩',

  zh: '🇨🇳', ja: '🇯🇵', ko: '🇰🇷',

  la: '🇻🇦' 
}



const currentLangName = computed(() => `${languages[locale.value]} ${flags[locale.value]}`)

const setLang = (code) => {
  locale.value = code
  localStorage.setItem('lang', code)
}

let intervalId = null

const startBackground = () => {
  const ctx = canvas.value.getContext('2d')
  canvas.value.width = window.innerWidth
  canvas.value.height = window.innerHeight

const alphabetMap = {
  ro: 'ABCDEFGHIJKLMNOPQRSTUVWXYZĂÂÎȘȚ',
  en: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  fr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÀÂÇÉÈÊËÎÏÔÙÛÜŸ',
  de: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜẞ',
  es: 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ',
  it: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  bg: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯ',
  hu: 'AÁBCDEÉFGHIÍJKLMNOÓÖŐPQRSTUÚÜŰVWXYZ',
  pl: 'AĄBCĆDEĘFGHIJKLŁMNŃOÓPQRSŚTUVWXYZŹŻ',
  cs: 'AÁBCČDĎEÉĚFGHIÍJKLMNŇOÓPQRŘSŠTŤUÚŮVYZŽ',
  sk: 'AÁÄBCČDĎDEÉFGHIÍJKLĽMNŇOÓÔPQRŔSŠTŤUÚVÝZŽ',
  sl: 'AĄBCČDEFGHIJKLMNOPRSŠTUVZŽ',
  sq: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÇË',
  sr: 'АБВГДЂЕЖЗИЈКЛЉМНЊОПРСТЋУФХЦЧЏШ',
  bs: 'AÄBCČĆDĐEFGHIJKLMNOPRSŠTUVZŽ',
  mk: 'АБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ',
  uk: 'АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ',
  ru: 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ',
  nl: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  sv: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ',
  no: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ',
  da: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ',
  fi: 'AÄBCDEFGHIJKLMNOPRSTUVWXYÖÅ',
  el: 'ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ',
  pt: 'ABCDEFGHIJKLMNOPQRSTUVWXYZÇÁÀÂÃÉÊÍÓÔÕÚÜ',
  tr: 'ABCÇDEFGĞHIİJKLMNOÖPRSŞTUÜVYZ',
  ar: 'ابتثجحخدذرزسشصضطظعغفقكلمنهوي',
  he: 'אבגדהוזחטיכלמנסעפצקרשת',
  fa: 'اآبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی',
  ur: 'اآابپتثجچحخدڈذرزژسشصضطظعغفقکگلنوموہیءی',
  af: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  ne: 'अआइईउऊएऐओऔअंअःकखगघङचछजझञटठडढणतथदधनपफबभमयरलवशषसह',
  hi: 'अआइईउऊऋएऐओऔअंअःकखगघङचछजझञटठडढणतथदधनपफबभमयरलवशषसह',
  th: 'กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮ',
  vi: 'AĂÂBCDĐEÊGHIKLMNOÔƠPQRSTUƯVXY',
  id: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  zh: '的一是在不了有和人这中大为上个国我以要他时来用们生到作地于出就分对成会可主发年动同工也能下过子说产种面而方后多定行学法所民得经十三之进着等部度家电力里如水化高自二理起小物现实加量都两体制机当使点从业本去把性好应开它合还因由其些然前外天政四日那社义事平形相全表间样与关各重新线内数正心反你明看原又么利比或但质气第向道命此变条只没结解问意建月公无系军很情者最立代想已通并提直题党程展五果料象员革位入常文总次品式活设及管特件长求老头基资边流路级少图山统接知较将组见计别她手角期根论运农指几九区强放决西被干做必战先回则任取据处队南给色光门即保治北造百规热领七海口东导器压志世金增争济阶油思术极交受联什认六共权收证改清己美再采转更单风切打白教速花带安场身车例真务具万每目至达走积示议声报斗完类八离华名确才科张信马节话米整空元况今集温传土许步群广石记需段研界拉林律叫且究观越织装影算低持音众书布复容儿须际商非验连断深难近矿千周委素技备半办青省列习便响约支般史感劳便团往酸历市克河火带',
  ja: 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン',
  ko: '가나다라마바사아자차카타파하거너더러머버서어저처커터퍼허고노도로모보소오조초코토포호',
  la: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
}


  const letters = (alphabetMap[locale.value] || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').repeat(10).split('')
  const fontSize = 10
  const columns = Math.floor(canvas.value.width / fontSize)
  const drops = Array(columns).fill(1)

  if (intervalId) clearInterval(intervalId)

  intervalId = setInterval(() => {
    ctx.fillStyle = 'rgba(0, 0, 0, .1)'
    ctx.fillRect(0, 0, canvas.value.width, canvas.value.height)
    drops.forEach((y, x) => {
      const text = letters[Math.floor(Math.random() * letters.length)]
      ctx.fillStyle = '#0ff'
      ctx.fillText(text, x * fontSize, y * fontSize)
      if (y * fontSize > canvas.value.height && Math.random() > 0.975) drops[x] = 0
      drops[x]++
    })
  }, 33)
}
const filteredLanguages = computed(() => {
  const term = searchTerm.value.toLowerCase()
return Object.entries(languages)
  .filter(([name]) => name.toLowerCase().includes(term))
  .map(([code, name]) => ({ code, name }))

})

onMounted(() => {
  locale.value = localStorage.getItem('lang') || 'ro'
  startBackground()
})

watch(locale, () => {
  startBackground()
  useHead({
    title: t('home.seo_title'),
    meta: [
      { name: 'description', content: t('home.seo_description') },
      { name: 'keywords', content: t('home.seo_keywords') }
    ]
  })
})
</script>

<style>
.bg-canvas {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100vw;
  height: 100vh;
  background: black;
}* {
  transition: all 0.3s ease;
}

.btn.nav-btn {
  color: #fff;
  font-style: bold;
  border-color: #00ffcc;
}

.nav-btn-active {
  color: #111 !important;
  background-color: #00ffcc !important;
  
  border-color: #00ffcc;
}
.btn-outline-primary.active {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.lang-dropdown .dropdown-toggle {
  border-color: #00ffcc;
  color: #00ffcc;
  background: transparent;
  font-family: 'Fira Code', monospace;
}
.border-primary {
  border-color: #00ffcc !important;
}
.floating-btn {
  text-decoration: none; /* 🔥 elimină linia */
}
.floating-btn i {
  pointer-events: none; /* optional, pt. hover strict pe cerc */
}

.lang-dropdown .dropdown-menu {
  background-color: #111;
  border: 1px solid #00ffcc33;
  font-family: 'Fira Code', monospace;
}

.lang-dropdown .dropdown-item {
  color: white;
  transition: background-color 0.2s;
}
.lang-dropdown .dropdown-item:hover {
  background-color: #00ffcc33;
  color: #00ffcc;
}

.app {
  font-family: 'Fira Code', monospace;
  font-size: 16px;
}

.terminal-box {
  width: 90vw;
  max-width: 950px;
  background-color: rgba(17, 17, 17, 0.7); /* semi transparent */
  border: 2px solid #00ffcc;
  backdrop-filter: blur(2px);
}

.terminal-title {
  font-size: 1.2rem;
  font-weight: bold;
  font-family: 'Fira Code', monospace;
}

.logo-terminal {
  height: 64px;
  opacity: 0.8;
}

.terminal-header {
  font-size: 1rem;
  border-bottom: 1px solid #00ffcc;
}

button.active {
  background-color: #00ffcc;
  color: black;
}

/* WhatsApp floating */
/* Common styles for floating buttons */
.floating-btn {
  position: fixed;
  right: 20px;
  z-index: 999;
  color: white;
  font-size: 24px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.floating-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease, transform 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

/* WhatsApp button */
.whatsapp-float {
  bottom: 20px;
  background: linear-gradient(135deg, #25d366, #128c7e);
  animation: popIn 1.2s ease-out 1.5s backwards;
}
.whatsapp-float i {
  margin-top: 1px;
}

/* Telegram button */
.telegram-float {
  bottom: 90px;
  background: linear-gradient(135deg, #0088cc, #005f99);
  animation: popIn 1.2s ease-out 1.7s backwards;
}
.telegram-float i {
  margin-top: 1px;
}

/* Fade in terminal box */
.terminal-box {
  animation: fadeInTerminal 1s ease-in-out;
}

@keyframes fadeInTerminal {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Pulse on hover nav buttons */
.nav-btn {
  transition: all 0.2s ease;
}
.nav-btn:hover {
  background-color: #00ffcc88;
  transform: scale(1.05);
}

/* Shine effect on logo */
.logo-terminal {
  position: relative;
  overflow: hidden;
}
.logo-terminal::after {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transform: skewX(-25deg);
  animation: shine 3s infinite;
}.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #00ffccd8;
  border-radius: 8px;
}
.map-box {
  height: 100%;
  min-height: 300px;
  border: 2px solid #00ffcc;
  background-color: #111;
  box-shadow: 0 0 10px #00ffcc33;
  transition: box-shadow 0.3s ease;
}
.map-box:hover {
  box-shadow: 0 0 20px #00ffcc;
}
@media (max-width: 768px) {
  .nav-btn {
    width: 100%;
    text-align: center;
  }
  .lang-dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
  }
}
.custom-input {
  width: 100%;
  background-color: #222;
  border: 1px solid #00ffcc;
  color: white;
  font-family: 'Fira Code', monospace;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px transparent;
}

.custom-input:focus {
  border-color: #00ffcc;
  box-shadow: 0 0 8px #00ffccaa;
  background-color: #111;
}

.text-primary {
  color: #00ffcc !important;
}
.btn-outline-primary {
  position: relative;
  color: #00ffcc !important;
  border: 2px solid #00ffcc;
  background-color: transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 0 8px transparent;
}
input.custom-input,
textarea.custom-input {
  color: #fff !important;
}

.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary:disabled {
  color: #fff !important;
  border-color: #00a584;
  transform: translateY(-2px);
}
@keyframes shine {
  0% {
    left: -75%;
  }
  100% {
    left: 125%;
  }
}

/* WhatsApp btn pop-in */
.whatsapp-float {
  animation: popIn 1.2s ease-out 1.5s backwards;
}

@keyframes popIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

</style>
